import { ALL_GROUPS } from "src/features/groups/groups";
import DocsPage from "./docs-page";
import withProtectedRoute from "src/features/auth/components/withProtectedRoute";
import { UrlRoutes } from "src/features/site/types/routes.types";

export default withProtectedRoute(DocsPage, UrlRoutes.Login, ALL_GROUPS);
